<template>
  <div>
    <div class="text-h5">Versenden</div>
    <br><br>
    <v-spacer></v-spacer>
    <PostTrackingCodeScanning
        :open="orderLoaded"
        ref="posttrackingscanner"
        @scannedPostTrackingCodes="scannedPostTrackingCodes"
        @close="orderLoaded = null"
    >
      <template v-if="orderLoaded">
        Auftrag #{{ orderLoaded.no }}
      </template>
    </PostTrackingCodeScanning>
    <v-alert
        v-for="(e, idx) in log"
        :key="idx"
        :type="e.code === 'ok' ? 'success' : 'error'"
        prominent
    >
      <v-row align="center">
        <v-col class="grow">
          {{ e.message }}
        </v-col>
        <v-col class="shrink" v-if="e.data && e.data.actions">
          <nobr>
            <v-btn
                v-for="(action, idx2) in e.data.actions"
                :key="idx2"
                color="primary"
                @click="runAction(action)"
                class="mb-3"
            >
              <template v-if="action.type === 'printShipment'">
                <v-icon left dark>mdi-printer</v-icon> Lieferschein
              </template>
              <template v-else-if="action.type === 'printInvoice'">
                <v-icon left dark>mdi-printer</v-icon> Rechnung
              </template>
              <template v-else>
                {{ action.type }}
              </template>
            </v-btn>
          </nobr>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import PostTrackingCodeScanning from '@/components/PostTrackingCodeScanning.vue';
import * as Sentry from '@sentry/vue';

export default {
  name: 'OrderSent',
  components: { PostTrackingCodeScanning },
  data() {
    return {
      log: [],
      orderLoaded: null,
      postTracingCodeScanningActive: false
    };
  },
  methods: {
    scancode(data) {
      console.log('[OrderSent] scancode received:', data, 'orderLoaded:', this.orderLoaded);
      if (this.orderLoaded) {
        console.log('[OrderSent] delegating scan to PostTrackingCodeScanning');
        return this.$refs.posttrackingscanner.scancode(data);
      }

      if (data.type !== 'document') {
        console.warn('[OrderSent] invalid type, expected document');
        return this.alert({ type: 'error', message: 'Scanne zuerst ein Dokument ein' });
      }

      const postData = { [`${data.documentType}Id`]: data.id };
      console.log('[OrderSent] checking order with:', postData);
      this.runAction({ type: 'checkOrder', data: postData }, this.onOrderLoaded);
    },

    alert(data) {
      console.log('[OrderSent] log entry:', data);
      this.log.unshift(data);
    },

    onOrderLoaded(response) {
      console.log('[OrderSent] onOrderLoaded response:', response);
      if (response.code === 'error') {
        console.error('[OrderSent] error loading order:', response.message);
        return this.alert(response);
      }

      if (response.data.status !== 'produced') {
        console.warn('[OrderSent] wrong status:', response.data.status);
        return this.alert({
          type: 'error',
          message: `Der Auftrag #${response.data.no} hat nicht den Status "produziert"`
        });
      }

      if (response.data.isPickupOrder === true) {
        console.log('[OrderSent] pickup order, auto-sending');
        return this.runAction(
            { type: 'orderSent', data: { orderId: response.data.id } }
        );
      }

      console.log('[OrderSent] order loaded for scanning:', response.data);
      this.orderLoaded = response.data;
    },

    runAction(action, next) {
      console.log('[OrderSent] runAction:', action);
      this.$axios
          .post(`/api/work/${action.type}`, action.data)
          .then((res) => {
            console.log(`[OrderSent] ${action.type} response:`, res.data);
            if (typeof next === 'function') {
              return next(res.data);
            }
            this.alert(res.data);
          })
          .catch((err) => {
            console.error(`[OrderSent] ${action.type} failed:`, err);
            // Track error in Sentry if it's initialized
            if (this.$env.VUE_APP_SENTRY_DSN && this.$env.VUE_APP_SENTRY_DSN.trim() !== '') {
              Sentry.captureException(err);
            }

            // Try to get the error message from the server response
            let errorMessage = 'Netzwerkfehler beim Ausführen der Aktion';
            if (err.response && err.response.data) {
              if (err.response.data.message) {
                errorMessage = err.response.data.message;
              } else if (err.response.data.error) {
                errorMessage = err.response.data.error;
              }
            }

            this.alert({ type: 'error', message: errorMessage });
          });
    },

    scannedPostTrackingCodes(trackingCodes) {
      console.log('[OrderSent] scannedPostTrackingCodes:', trackingCodes);
      this.runAction(
          {
            type: 'orderSent',
            data: { orderId: this.orderLoaded.id, trackingCodes }
          }
      );
      this.orderLoaded = null;
      console.log('[OrderSent] reset orderLoaded to null after sending');
    },
  },
};
</script>
